// extracted by mini-css-extract-plugin
export default {"container":"MonsterPaper_container__w4T+o","contentContainer":"MonsterPaper_contentContainer__J8gjm","monsterContainer":"MonsterPaper_monsterContainer__XukB3"};